import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Una vez realizado el pago, recibirás un correo electrónico con el enlace para acceder y descargar todo el material inmediatamente.'
  }, {
    q: '¿Los archivos son PDF?',
    a: 'Sí, todos los tomos y bonos están en formato PDF de alta calidad, optimizados para lectura digital.'
  }, {
    q: '¿Puedo leerlos desde el celular?',
    a: '¡Por supuesto! El formato es 100% compatible con celulares, tablets y computadoras.'
  }, {
    q: '¿Necesito conocimientos previos?',
    a: 'No, la colección está diseñada para que cualquier persona pueda aprender desde cero, de forma clara y entretenida.'
  }, {
    q: '¿Los bonos están incluidos?',
    a: 'Sí, al adquirir la colección hoy, recibís los 3 bonos exclusivos sin costo adicional.'
  }, {
    q: '¿Es un pago único?',
    a: 'Sí, es un único pago. No hay suscripciones ni cobros mensuales ocultos.'
  }, {
    q: '¿Tengo acceso de por vida?',
    a: 'Así es. Una vez que descargás el material, es tuyo para siempre.'
  }, {
    q: '¿Qué pasa si no cumple mis expectativas?',
    a: 'Tenés 7 días de garantía. Si no estás conforme, solicitás el reembolso y te devolvemos el 100% de tu dinero.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-dark-card/30" data-id="element-75">
      <div className="max-w-3xl mx-auto" data-id="element-76">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-77">
          PREGUNTAS FRECUENTES
        </motion.h2>

        <div className="space-y-4" data-id="element-78">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-dark-border rounded-xl bg-dark overflow-hidden" data-id="element-79">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-80">
                <span className="font-bold text-white pr-8" data-id="element-81">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-82" />
              </button>

              <AnimatePresence data-id="element-83">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-84">
                    <div className="px-6 pb-6 text-gray-300 leading-relaxed border-t border-dark-border/50 pt-4" data-id="element-85">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}